import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import IconPackage from 'xiv-fanfes-2021'
import { useLocalization } from "gatsby-theme-i18n";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";
import YouTube from 'react-lite-youtube-embed';
import LinkItem from '../../../components/LinkItem';
import AnimatedSection from '../../../components/AnimatedSection';
import * as breakpoint from '../../../styles/breakpoints.module.scss';


const Embed = ({ currentDay }) => {
  const { t } = useLocalization();

  const [ currentSource, setCurrentSource ] = useState('');

  const data = useStaticQuery(graphql`
  query EmbedComponent {
    placeholder : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/streaming/embed_bg.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
  }
`); 

useEffect(() => {
  if(currentDay === 2 && currentSource === `twitch3`)
    setCurrentSource('twitch1');
  if(currentSource === '')
    setCurrentSource('twitch1')
}, [currentDay, currentSource]);


  return (
    <AnimatedSection>
      <EmbedWrapper>
        <StreamingFrameWrapper>
          <StreamingFrame source={currentSource} day={currentDay} />
        </StreamingFrameWrapper>
      <BgFrame>
        <GatsbyImage image={getImage(data.placeholder)} alt="streamingBackground"/>
      </BgFrame>
    </EmbedWrapper>
    <SourceList>
      <SourceIndicator>
        <span>
          {t(`event.date.day${currentDay}.label`)}&nbsp;
          {
            currentSource === "youtube" ? 
              "Youtube" :
            currentSource === "niconico" ?
              "ニコニコ動画" :
            `Twitch ${currentSource.replace('twitch','')}/${currentDay === 1 ? '3' : '2'}`
          }
        </span>
      </SourceIndicator>
      <div>
        {currentDay === 1 ?
          <>
            <Source className={`twitch ${currentSource==="twitch1" ? "active" : ""}`} href={t('nav.streaming.twitch.archive.day1_1.url')} onClick={(e) => {
              e.preventDefault();
              setCurrentSource('twitch1');
            }}>
              <IconPackage.Icon type={'Twitch'} alt={'Twitch'} />
            </Source>
            <Source className={`twitch disabled`}>
              <IconPackage.Icon type={'Twitch'} alt={'Twitch'} />
            </Source>
            <Source className={`twitch ${currentSource==="twitch3" ? "active" : ""}`} href={t('nav.streaming.twitch.archive.day1_3.url')} onClick={(e) => {
              e.preventDefault();
              setCurrentSource('twitch3');
            }}>
              <IconPackage.Icon type={'Twitch'} alt={'Twitch'} />
            </Source>
          </>
        :
          <>
            <Source className={`twitch ${currentSource==="twitch1" ? "active" : ""}`} href={t('nav.streaming.twitch.archive.day2_1.url')} onClick={(e) => {
              e.preventDefault();
              setCurrentSource('twitch1');
            }}>
              <IconPackage.Icon type={'Twitch'} alt={'Twitch'} />
            </Source>
            <Source className={`twitch ${currentSource==="twitch2" ? "active" : ""}`} href={t('nav.streaming.twitch.archive.day2_2.url')} onClick={(e) => {
              e.preventDefault();
              setCurrentSource('twitch2');
            }}>
              <IconPackage.Icon type={'Twitch'} alt={'Twitch'} />
            </Source>
          </>
        }
        
        <Source className={`youtube disabled`}>
          <IconPackage.Icon type={'Youtube'} alt={'Youtube'} />
        </Source>
        <Source className={`niconico ${currentSource==="niconico" ? "active" : ""}`} href={t(`nav.streaming.niconico.day${currentDay}.url`)} onClick={(e) => {
          e.preventDefault();
          setCurrentSource('niconico');
        }}>
          <IconPackage.Icon type={'Niconico'} alt={'ニコニコ動画'} />
        </Source>
      </div>
    </SourceList>
  </AnimatedSection>);
}

const StreamingFrame = ({ source , day}) => {
  const { t , currentLocaleObj} = useLocalization();

  const opts = {
    autoplay: true
  };

  if(source === 'twitch1' || source === 'twitch2' || source === 'twitch3')
  {
    let part = source.replace(`twitch`,'')
    let channelArr = t(`nav.streaming.twitch.archive.day${day}_${part}.url`).split('/');
    let parent = typeof window !== "undefined" ? window.location.hostname : 'localhost';
    return (<iframe src={`https://embed.twitch.tv?autoplay=true&video=${channelArr[channelArr.length - 1]}&height=100%25&layout=video&muted=false&parent=${parent}&targetId=twitch-embed&width=100%25`} allowFullScreen="" scrolling="no" frameBorder="0" allow="autoplay; fullscreen" title="Twitch" sandbox="allow-modals allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox" width="100%" height="100%"></iframe>);
    //return(<ReactTwitchEmbedVideo channel={channelArr[channelArr.length - 1]} layout={'video'} width={'100%'} height={'100%'}/>)
  } else if(source === 'youtube')
  {
    let id = t(`nav.streaming.youtube.day${day}.url`).replace('https://youtu.be/','')
    return(<YouTube id={id} autoplay={true} poster="maxresdefault" />)
  } else if(source === 'niconico')
  {
    let id = t(`nav.streaming.niconico.day${day}.url`).split('/')
    
    
    return( 
      <NiconicoFrame 
        width="312"
        height="176" 
        src={`https://live.nicovideo.jp/embed/${id[id.length - 1]}`} scrolling="no"  frameBorder="0">
        <a href={`https://live.nicovideo.jp/watch/${id[id.length - 1]}`}>FINAL FANTASY XIV DIGITAL FAN FESTIVAL 2021 - Day{day}</a>
      </NiconicoFrame>
    )
  }
  else {
    return(<div></div>)
  }
    
}
 
export default Embed;

const EmbedWrapper = styled.div`
  position:relative;
`

const BgFrame = styled.div`
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  overflow:hidden;
  position:relative;
  z-index:1;
`

const SourceList = styled.div`
  text-align:right;
  margin-top:16px;
  display:flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    text-align:center;
    display:block;
  }
`

const SourceIndicator = styled.div`
  justify-self: flex-start;
  font-size: 20px;
  line-height: 32px;
  font-weight: 900;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 16px;
    line-height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:16px;
    font-size: 14px;
    line-height: 20px;
  }
`

const Source = styled(LinkItem)`
  width:40px;
  height:40px;
  display:inline-block;
  background: #FCFCFF;
  border: 1px solid #ECECEF;
  box-sizing: border-box;
  border-radius: 6px;
  margin-left:8px;

  transition: background .3s, border-color .3s;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 4px;
  }

  > svg{
    display:block;
    width:24px;
    height:24px;
    color:#4E4E50;
    margin:7px;
    transition: color .3s,
  }

  &.disabled{
    background: #CACACD;
    border-color: #CACACD;
    > svg {
      color: #F2F2F5;
    }
  }

  &:hover:not(.disabled):not(.active){
    background: #FCFCFF;
    &.youtube{
      
      border-color: #FF0000;
      > svg{
        color:#FF0000;
      }
    }
    &.twitch{
      border-color: #9146FF;
      > svg{
        color:#9146FF;
      }
    }
    &.niconico{
      border-color: #4E4E50;
      > svg{
        color:#4E4E50;
      }
    }
  }

  &.active{
    > svg{
      color:#FCFCFF;
    }
    &.youtube{
      background: #FF0000;
      border-color: #FF0000;
    }
    &.twitch{
      background: #9146FF;
      border-color: #9146FF;
    }
    &.niconico{
      background: #4E4E50;
      border-color: #4E4E50;
    }
  }
`

const StreamingFrameWrapper = styled.div`
  position:absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  z-index: 3;

  > div{
    width:100%;
    height:100%;
  }

  
`

const NiconicoFrame = styled.iframe`
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  border: 1px solid rgb(208, 208, 208); 
  background-color: rgb(246, 246, 246);
`
